import { InnerHTMLDiv, OdinIcon } from '@myosh/odin-components';
import DOMPurify from 'dompurify';
import React, { forwardRef, useImperativeHandle, useState, type Ref } from 'react';

interface AIAnalysisSuggestionContainerProps {}

export interface AIAnalysisSuggestionContainerRef {
  show: (text: string) => void;
}

export const AIAnalysisSuggestionContainer = (
  _props: AIAnalysisSuggestionContainerProps,
  ref: Ref<AIAnalysisSuggestionContainerRef>
): React.JSX.Element => {
  const [suggestion, setSuggestion] = useState<string>();

  const show = (suggestion: string) => {
    setSuggestion(suggestion);
  };

  useImperativeHandle(ref, () => {
    return { show };
  });

  const handleClickClose = () => {
    setSuggestion(undefined);
  };

  if (!suggestion) {
    return <></>;
  }

  return (
    <div
      data-cy="ai-analysis-suggestion-container"
      className="bt-mb-4 bt-ml-16 bt-mt-4 bt-flex bt-h-fit bt-max-h-[200px] bt-w-[75%] bt-flex-col bt-rounded bt-border bt-border-gray-1 bt-bg-mono-1 bt-p-4"
    >
      <div className="bt-flex bt-cursor-pointer bt-flex-row bt-items-center bt-justify-between">
        <label data-cy="ai-analysis-title" className="bt-font-bold">
          AI Analysis
        </label>
        <div data-cy="ai-analysis-close-button" onClick={handleClickClose}>
          <OdinIcon icon="X" />
        </div>
      </div>

      <hr className="bt-mb-4 bt-mt-4 bt-border-gray-4" />

      <div
        data-cy="ai-analysis-content-wrapper"
        className="bt-max-h=[200px] bt-flex bt-h-full bt-overflow-y-auto bt-overflow-x-hidden bt-whitespace-pre-line bt-text-wrap bt-text-sm"
      >
        <InnerHTMLDiv data-cy="ai-analysis-content" html={sanitizeHtml(suggestion)} />
      </div>
    </div>
  );
};

// util
const sanitizeHtml = (value: string) => {
  return DOMPurify.sanitize(value, { USE_PROFILES: { html: true } });
};

export default forwardRef(AIAnalysisSuggestionContainer);
